import { useMediaQuery } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { DefaultInfo } from "components/NothingRight";
import { theme } from "config/theme";
import { NewJobCreation } from "domains/Job/components/JobCreation";
import { JobDescription } from "domains/Job/components/JobDescription";
import { NewJobContext } from "domains/Job/context";
import React from "react";

const useStyles = makeStyles<Theme>(() =>
  createStyles({
    left: {
      width: "70%",
      margin: "20px 25px",
    },
    right: {
      width:  "30%",
      backgroundColor: "#fff",
    },
    root: {
      backgroundColor: "#f5f6f8",
      display: "flex",
      flexDirection: "row",
      width: "100%",
      paddingTop: 60
    },
    root1: {
      backgroundColor: "#f5f6f8",
      display: "flex",
      width: "100%",
      flexDirection: "column",
    },
  })
);

export function Job() {
  const context = React.useContext(NewJobContext);
  const styles = useStyles();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <div className={isSmallScreen ? styles.root1 : styles.root}>
      <div
        className={styles.left}
        style={{
          width: isSmallScreen ? "100%" : "70%",
        }}
      >
        <NewJobCreation />
      </div>

      {!isSmallScreen && (
        <div className={styles.right}>{context?.job !== null && !context?.tuck ? <JobDescription /> : <DefaultInfo />}</div>
      )}
    </div>
  );
}
export default Job;
